import React from "react";
// import { Link } from "react-router-dom";

import { FormattedMessage, IntlProvider } from "react-intl";
import { useNavigate } from "react-router-dom";

import messages_en from "./translations/en.json";
import messages_pt from "./translations/pt.json";
import messages_fr from "./translations/fr.json";

import { FiSun } from "react-icons/fi"; // Import FiSun from react-icons/fi
// import { HiChevronRight } from "react-icons/hi2";
import Button from "@mui/material/Button";
import { HiOutlineBolt, HiArrowLongRight, HiStop } from "react-icons/hi2";

const messages = {
    en: messages_en,
    pt: messages_pt,
    fr: messages_fr,
};

const ClientNew = ({
    client,
    alert,
    language,
    last_interaction,
    isFirst,
    isLast,
    unique_result,
}) => {
    const nav = useNavigate();

    const formatDate = (timestamp) => {
        if (!timestamp) return "-";
        const date = new Date(timestamp);
        return date.toLocaleDateString("fr-FR", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    const handleNavigation = () => {
        if (client.is_lead) {
            // First navigate to the lead page
            nav(`/lead/${client.client_id}`);
        } else {
            // Navigate to the client page
            nav(`/client/${client.client_id}`);
        }
    };

    const getBorderStyles = () => {
        if (isFirst) {
            return unique_result
                ? "rounded-xl border-b-1"
                : "rounded-t-xl border-b-0";
        }
        if (isLast) {
            return unique_result
                ? "rounded-b-xl border-t-1"
                : "rounded-b-xl border-t-1";
        }
        return "border-t-1 border-b-0";
    };

    return (
        client && (
            <IntlProvider locale={language} messages={messages[language]}>
                <div
                    onClick={handleNavigation}
                    style={{ cursor: "pointer" }}
                    className={`flex px-2 md:p-1 w-full md:w-full flex-row items-center justify-between transform bg-white border border-gray-100 ${getBorderStyles()}`}
                >
                    <div className="w-5/6  flex flex-row items-center">
                        <div className="relative float-left p-2  flex-row items-center w-5/6">
                            <h2 className="flex text-base text-black">
                                <span className="font-bold">
                                    {client?.client_name &&
                                        client?.client_name
                                            .split(" ")
                                            .map(
                                                (word) =>
                                                    word
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                    word.slice(1).toLowerCase()
                                            )
                                            .join(" ")}
                                    <span className="text-xs">
                                        ,{" "}
                                        {client?.city &&
                                            client?.city
                                                .split(" ")
                                                .map(
                                                    (word) =>
                                                        word
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                        word
                                                            .slice(1)
                                                            .toLowerCase()
                                                )
                                                .join(" ")}
                                    </span>
                                </span>

                                {client?.is_seasonal && (
                                    <FiSun className="ml-2" />
                                )}
                            </h2>

                            <div className="flex flex-col md:flex-col">
                                {!client.is_lead && (
                                    <h2 className="flex tracking-widest text-xxs text-black ">
                                        ID: {client?.client_id}
                                    </h2>
                                )}

                                <h2 className="flex tracking-widest text-xxs text-black ">
                                    Dernière interaction:{" "}
                                    {formatDate(last_interaction)}
                                </h2>
                            </div>
                        </div>
                        <div className="flex w-1/6">
                            <h2
                                className="items-center font-semibold tracking-wide text-center md:w-full"
                                style={{ color: "#E0115F" }}
                            >
                                {!client?.is_active && (
                                    <span
                                        className="inline-block py-1 px-1 text-white bg-rose-500 text-xxs rounded-full md:rounded-md  w-full flex items-center justify-center gap-1"
                                        data-config-id="change2"
                                    >
                                        <HiStop style={{ strokeWidth: 1.5 }} />
                                        <span className="hidden md:block">
                                            Inactif
                                        </span>
                                    </span>
                                )}
                                {alert && client?.is_active && (
                                    <>
                                        {/* Gold dot for smaller screens */}
                                        <div
                                            className="inline-block py-1 text-black rounded-full md:rounded-md bg-gold font-semibold text-xs md:text-xxs flex items-center justify-center gap-1" // Show dot only on small screens
                                        >
                                            <HiOutlineBolt
                                                style={{ strokeWidth: 1.5 }}
                                            />

                                            <span className="hidden md:block">
                                                <FormattedMessage
                                                    id="client.new_reco"
                                                    values={{ number: 1 }}
                                                />
                                            </span>
                                        </div>
                                    </>
                                )}
                            </h2>
                        </div>
                    </div>

                    <div className="w-1/6 flex flex-col justify-center items-center md:mb-0">
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation(); // Prevent event bubbling to parent div
                                handleNavigation();
                            }}
                            sx={{
                                borderRadius: "8px",
                                padding: "2px 10px",
                                height: 24,
                                backgroundColor: "#282828",
                            }}
                        >
                            <span className="flex items-center gap-2">
                                <FormattedMessage
                                    id="client.details"
                                    values={{ number: 1 }}
                                />{" "}
                                <span className="hidden md:block">
                                    <HiArrowLongRight
                                        style={{ strokeWidth: 1.2 }}
                                    />
                                </span>
                            </span>
                        </Button>
                    </div>
                </div>
            </IntlProvider>
        )
    );
};

export default ClientNew;
